import { render, staticRenderFns } from "./selectedUsers.vue?vue&type=template&id=d15ed920&scoped=true&"
import script from "./selectedUsers.ts?vue&type=script&lang=ts&"
export * from "./selectedUsers.ts?vue&type=script&lang=ts&"
import style0 from "./selectedUsers.scss?vue&type=style&index=0&id=d15ed920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15ed920",
  null
  
)

export default component.exports